import { Link } from "react-router-dom";
import { categoryShortcuts } from "@/mocks/site";

export default function CategorySection() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl text-foreground-950">角色快捷入口</h2>
          <p className="mt-1 text-sm text-foreground-600">按属性划分，快速找到你的本命角色</p>
        </div>
        <Link
          to="/roles"
          className="hidden items-center gap-1 text-sm text-primary-600 transition-colors hover:text-primary-700 sm:flex"
        >
          全部角色
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-6">
        {categoryShortcuts.map((cat) => (
          <Link
            key={cat.id}
            to={`/roles?tag=${encodeURIComponent(cat.name)}`}
            className="group flex flex-col items-center rounded-lg border border-background-200 bg-background-50 p-4 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:bg-background-100/70"
          >
            <span className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950">
              <i className={`${cat.icon} text-2xl`}></i>
            </span>
            <h3 className="font-heading text-base text-foreground-950">{cat.name}</h3>
            <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{cat.desc}</p>
            <span className="mt-2 text-xs text-secondary-600">{cat.count} 位角色</span>
          </Link>
        ))}
      </div>
    </section>
  );
}